// AdminDashboard.jsx
import { useEffect, useState } from "react";
import { supabase } from "./SuperbaseClient";
import { Link } from "react-router-dom";
import Select from "react-select";

// import logo from "../../images/footer/footerLogo.png";
import logo from "../../images/footer/carzenFlogo.png";

export default function AdminForms() {
  const [forms, setForms] = useState([]);
  const [loading, setLoading] = useState(true);
  const [err, setErr] = useState("");
  const [selected, setSelected] = useState(null);
  const [filters, setFilters] = useState({
    startDate: "",
    endDate: "",
    // city: "",
    location: "",
  });

  const locationOptions = [
    { value: "Mumbai", label: "Mumbai" },
    { value: "Delhi", label: "Delhi" },
    { value: "Bengaluru", label: "Bengaluru" },
    { value: "Chennai", label: "Chennai" },
    { value: "Hyderabad", label: "Hyderabad" },
    { value: "Kolkata", label: "Kolkata" },
    { value: "Pune", label: "Pune" },
    { value: "Ahmedabad", label: "Ahmedabad" },
    { value: "Jaipur", label: "Jaipur" },
    { value: "Chandigarh", label: "Chandigarh" },
    { value: "Indore", label: "Indore" },
    { value: "Bhopal", label: "Bhopal" },
    { value: "Lucknow", label: "Lucknow" },
    { value: "Kanpur", label: "Kanpur" },
    { value: "Noida", label: "Noida" },
    { value: "Gurgaon", label: "Gurgaon" },
    { value: "Faridabad", label: "Faridabad" },
    { value: "Ghaziabad", label: "Ghaziabad" },
  ];

  const email = localStorage.getItem("admin_email");
  //const password = localStorage.getItem("admin_password");
  const sortedForms = [...forms].sort(
    (a, b) => new Date(b.created_at) - new Date(a.created_at)
  );

  // Fetch forms on mount
  const loadForms = async () => {
    setLoading(true);
    try {
      // FIXED ✔ correct table name + correct Supabase query
      const { data, error } = await supabase.from("carzenform").select("*");

      if (error) {
        setErr(error.message);
        return;
      }

      setForms(data);
    } catch {
      setErr("Network Error");
    } finally {
      setLoading(false);
    }
  };

  const filteredForms = sortedForms.filter((f) => {
    const bookingStart = f.start_date; // YYYY-MM-DD
    const bookingEnd = f.end_date; // YYYY-MM-DD

    // Filter by selected start date
    if (filters.startDate) {
      if (!bookingEnd || bookingEnd < filters.startDate) return false;
    }

    // Filter by selected end date
    if (filters.endDate) {
      if (!bookingStart || bookingStart > filters.endDate) return false;
    }

    // City filter
    // if (
    //   filters.city &&
    //   f.city &&
    //   !f.city.toLowerCase().includes(filters.city.toLowerCase())
    // ) {
    //   return false;
    // }

    // Location filter
    if (
      filters.location &&
      f.location &&
      !f.location.toLowerCase().includes(filters.location.toLowerCase())
    ) {
      return false;
    }

    return true;
  });

  useEffect(() => {
    loadForms();
  }, []);
  const handleLogout = () => {
    localStorage.removeItem("adminAuth", "false");
    localStorage.removeItem("admin_email");
    localStorage.removeItem("admin_password");
    window.location.href = "/admin-login";
  };

  // download
  const downloadCSV = () => {
    if (!filteredForms.length) return;

    const headers = [
      "Name",
      "Contact",
      "Service",
      "Package",
      "Start Date",
      "End Date",
      // "City",
      "Location",
      "Message",
      // "Submitted At",
    ];

    const rows = filteredForms.map((f) => [
      f.name,
      f.contact,
      f.service,
      f.package_type,
      f.start_date,
      f.end_date,
      // f.city,
      f.location,
      `"${f.message.replace(/"/g, '""')}"`,
      // new Date(f.created_at).toLocaleString(),
    ]);

    const csvContent =
      "data:text/csv;charset=utf-8," +
      [headers, ...rows].map((e) => e.join(",")).join("\n");

    const link = document.createElement("a");
    link.href = encodeURI(csvContent);
    link.download = "carzen_forms.csv";
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  // download single record
  const downloadSingleRecord = (record) => {
    if (!record) return;

    const headers = [
      "Name",
      "Contact",
      "Service",
      "Package",
      "Start Date",
      "End Date",
      "Location",
      "Message",
      "Submitted At",
    ];

    const row = [
      record.name,
      record.contact,
      record.service,
      record.package_type,
      record.start_date,
      record.end_date,
      record.location,
      `"${record.message.replace(/"/g, '""')}"`,
      // new Date(record.created_at).toLocaleString(),
    ];

    const csvContent =
      "data:text/csv;charset=utf-8," +
      [headers, row].map((e) => e.join(",")).join("\n");

    const link = document.createElement("a");
    link.href = encodeURI(csvContent);
    link.download = `carzen_form_${record.id}.csv`;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  return (
    <div className="w-full flex flex-col  min-h-screen">
      {/* Navbar */}
      <div className="w-full bg-[#FFF2E1] shadow flex flex-col sm:flex-row sm:items-center sm:justify-between px-4 sm:px-6 py-3 gap-2">
        <div className="flex justify-between items-center">
          <div>
            <Link to="/">
              <img
                src={logo}
                className="md:w-52 w-28 object-contain"
                alt="carzen Logo"
              />
            </Link>
          </div>
          <div className="sm:hidden text-sm text-gray-600">
            <h1 className="text-base">Admin</h1>
            <p className="text-[10px]">{email}</p>
          </div>
        </div>

        <div className="hidden sm:block text-sm text-gray-700">
          <h1 className="text-base">Admin</h1>
          <p className="text-[10px]">{email}</p>
        </div>
      </div>

      {/* Sidebar + Content */}
      <div className="flex flex-1 flex-col sm:flex-row">
        <div className="w-full sm:w-60 bg-[#FFF2E1] shadow-sm p-4 flex flex-col justify-between">
          <button className="text-left px-3 py-2 rounded bg-white w-full sm:w-auto sm:text-left">
            Overview
          </button>
          <button
            onClick={() => {
              handleLogout();
            }}
            className="text-red-600 text-right md:text-start font-semibold px-3 py-2 rounded bg-red-100"
          >
            Logout
          </button>
        </div>

        <div className="flex-1 p-4 sm:p-6">
          {loading && <p>Loading forms...</p>}
          {err && <p className="text-red-500">{err}</p>}

          <div>
            {/* FILTER BAR */}
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-3 bg-white p-4 rounded-lg border">
              <input
                type="date"
                value={filters.startDate}
                onChange={(e) =>
                  setFilters({ ...filters, startDate: e.target.value })
                }
                className="border rounded px-3 py-2 text-sm"
              />

              <input
                type="date"
                value={filters.endDate}
                onChange={(e) =>
                  setFilters({ ...filters, endDate: e.target.value })
                }
                className="border rounded px-3 py-2 text-sm"
              />
              <Select
                options={locationOptions}
                placeholder="Select Location"
                value={
                  locationOptions.find(
                    (opt) => opt.value === filters.location
                  ) || null
                }
                onChange={(option) =>
                  setFilters({
                    ...filters,
                    location: option ? option.value : "",
                  })
                }
                isClearable
                className="text-sm"
              />

              {/* <input
                type="text"
                placeholder="Location"
                value={filters.location}
                onChange={(e) =>
                  setFilters({ ...filters, location: e.target.value })
                }
                className="border rounded px-3 py-2 text-sm"
              /> */}

              <button
                onClick={() =>
                  setFilters({
                    startDate: "",
                    endDate: "",
                    city: "",
                    location: "",
                  })
                }
                className="bg-gray-100 text-sm rounded px-3 py-2 hover:bg-gray-200"
              >
                Clear
              </button>
              <button
                onClick={downloadCSV}
                className=" bg-black text-white px-4 py-2 rounded text-sm hover:bg-gray-800"
              >
                Download CSV
              </button>
            </div>

            {/* List Container */}
            <div className="mt-4 space-y-3">
              {filteredForms.map((f) => (
                <div
                  key={f.id}
                  onClick={() => setSelected(f)}
                  className="bg-white p-4 rounded-lg border cursor-pointer hover:shadow-md hover:scale-[1.01] transition-all"
                >
                  <div className="flex justify-between items-start gap-2">
                    <p className="text-gray-900 font-medium flex-1 break-words">
                      {f.message.length > 70
                        ? f.message.slice(0, 70) + "..."
                        : f.message}
                    </p>

                    <span className="text-xs text-gray-500 whitespace-nowrap">
                      {new Date(f.created_at).toLocaleString()}
                    </span>
                  </div>

                  <div className="text-sm text-gray-600 mt-2 break-words">
                    <span className="font-semibold">{f.name}</span> • {f.email}
                  </div>
                </div>
              ))}
            </div>

            {/* DETAILS MODAL */}
            {selected && (
              <div className="fixed inset-0 bg-black/40 flex items-center justify-center p-4">
                <div className="bg-white p-4 sm:p-6 rounded-lg shadow-xl max-w-lg w-full relative">
                  <button
                    onClick={() => setSelected(null)}
                    className="absolute top-3 right-3 text-gray-500 hover:text-black"
                  >
                    ✖
                  </button>

                  <h2 className="text-lg sm:text-xl font-semibold mb-3">
                    {selected.name}
                  </h2>

                  <p className="text-gray-700 mb-2 break-words">
                    <strong>Message:</strong> <br /> {selected.message}
                  </p>

                  <p className="text-gray-700 break-words">
                    <strong>Contact:</strong> {selected.contact}
                  </p>

                  {/* <p className="text-gray-700 break-words">
                    <strong>Phone:</strong> {selected.mobile || "-"}
                  </p> */}

                  <p className="text-gray-700 mt-2 break-words">
                    <strong>Service:</strong> {selected.service}
                  </p>
                  <p className="text-gray-700 break-words">
                    <strong>Package:</strong> {selected.package_type || "-"}{" "}
                    days
                  </p>
                  <p className="text-gray-700 break-words">
                    <strong>Start Date:</strong> {selected.start_date || "-"}
                  </p>
                  <p className="text-gray-700 break-words">
                    <strong>End Date:</strong> {selected.end_date || "-"}
                  </p>

                  <p className="text-gray-700 break-words">
                    <strong>Location:</strong> {selected.location || "-"}
                  </p>

                  <div className="mt-5 flex justify-between gap-3">
                    <p className="text-gray-500 text-sm mt-4">
                      <strong>Submitted:</strong>{" "}
                      {new Date(selected.created_at).toLocaleString()}
                    </p>
                    <button
                      onClick={() => downloadSingleRecord(selected)}
                      className="bg-black text-white px-4 py-2 rounded text-sm hover:bg-gray-800"
                    >
                      Download
                    </button>
                  </div>
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}
